import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconPinterest = (props: IconProps) => (
  <svg className={iconStyles(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.08 50.09">
    <path
      opacity=".5"
      fill="#FFF"
      d="M25 50.09A25 25 0 1 1 50.08 25 25.07 25.07 0 0 1 25 50.09zm0-48A22.92 22.92 0 1 0 48 25 22.94 22.94 0 0 0 25 2.13z"
    />
    <path
      opacity=".5"
      fill="#FFF"
      d="M25 13a12 12 0 0 0-4.81 23 10.46 10.46 0 0 1 .21-2.75l1.6-6.57a4.67 4.67 0 0 1-.38-1.9c0-1.78 1-3.1 2.31-3.1a1.61 1.61 0 0 1 1.62 1.8 25.93 25.93 0 0 1-1.06 4.25A1.86 1.86 0 0 0 26.36 30c2.27 0 3.8-2.92 3.8-6.37 0-2.63-1.76-4.6-5-4.6a5.68 5.68 0 0 0-5.91 5.74 3.46 3.46 0 0 0 .79 2.35c.23.27.26.37.18.67s-.19.76-.25 1a.41.41 0 0 1-.6.3c-1.67-.69-2.45-2.52-2.45-4.58 0-3.41 2.87-7.5 8.56-7.5 4.58 0 7.6 3.32 7.6 6.87 0 4.71-2.62 8.22-6.48 8.22a3.43 3.43 0 0 1-2.92-1.49s-.7 2.76-.85 3.3a10.06 10.06 0 0 1-1.2 2.56A11.83 11.83 0 0 0 25 37a12 12 0 0 0 0-24"
    />
  </svg>
);
